module.exports = {
	"header": "Centre d'aide",
	"account": "Compte",
	"categories": "Catégories",
	"category": {
		"return": "Retour au centre d'aide",
		"account": "Compte",
		"auction": "Encan",
		"bidding": "Offres",
		"payment": "Paiement"
	},
	"frequentlyAskedQuestions": "Questions fréquemment posées",
	"searchPlaceholder": "Tapez votre question ici...",
	"noArticle": "Il n'y a pas d'article dans cette catégorie.",
	"noResults": "Aucun résultat ne correspond à votre demande.",
	"searchResults": "Résultats de la recherche",
	"tryAgain": "S'il vous plaît essayez de nouveau."
}


//////////////////
// WEBPACK FOOTER
// /private/var/folders/n9/yczdnstj3wdc9q5tzm6d45c00000gp/T/maison-encans-auex-website/~/@auex/locales/lib/fr/help.json5
// module id = 1985
// module chunks = 6